<template>
  <div class="card mb_12" :class="[type == 'success' ? 'card_green' : 'card_red']">
    <div style="font-size: 14px" class="d-flex justify-content-between">
      <div class="d-flex">
        <div class="me-2" style="vertical-align: top;">
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<circle cx="11.9998" cy="12.0008" r="7.07692" :fill="type == 'success' ? '#51CF66' : '#FF1D53'" fill-opacity="0.5"/>
						<circle cx="11.9998" cy="12.0008" r="7.07692" :fill="type == 'success' ? '#51CF66' : '#FF1D53'"/>
						<ellipse cx="13.665" cy="11.1679" rx="2.91403" ry="2.91403" fill="white" fill-opacity="0.6"/>
					</svg>
				</div>
				<div class="d-flex justify-content-center align-items-center">{{text}}</div>
      </div>
      <div
        style="flex: 0 0 3%"
        class="d-flex justify-content-center align-items-center"
      >
        <div class="dropdown">
          <button
            type="button"
						style="background: unset"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            class="naked_button"
            id="dropdownMenuLink"
          >
            <i class="fa fa-ellipsis-v"></i>
          </button>

          <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <li><a class="dropdown-item" href="#">Action</a></li>
            <li><a class="dropdown-item" href="#">Another action</a></li>
            <li><a class="dropdown-item" href="#">Something else here</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item" href="#">Separated link</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	props: ['text', 'type'],
}
</script>